module.exports = __webpack_public_path__ + "img/z-4.c822a20c.png";